import API from '../../../services/apiService.js'

var api= new API();


export default {
    //получить список открытых заявок
    async getRequests({commit}) {
        var data = null;
        try {
            data = api.Get("RequestService/Request/NewRequestList");
            commit('loadNewRequests', await data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //получить архивные заявки
    async getAchiveRequests({commit}) {
        var data = null;
        try {
            data = api.Get("RequestService/Request/ArchiveList");
            commit('loadArchiveRequests', await data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //получить активные заявки
    async getActiveRequests({commit}) {
        var data = null;
        try {
            data = api.Get("RequestService/Request/ActiveRequestList");
            commit('loadActiveRequests', await data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //принять заявку
    async acceptRequest({commit}, model) {
        try {
            let data=null;
            await api.Post("RequestService/Request/Accept", model);
            var params = "?requestId=" + model.requestId
            data = await api.Get("RequestService/Request/RequestById" + params);
            commit('loadById', data);
        } catch (e) {
            console.log(e);
        }
    },

    //отклонить заявку
    async declineRequest({commit}, id) {
        try {
            var getparams = '?requestId=' + id;
            await api.Put("RequestService/Request/Reject" + getparams, null);
            commit('declineRequest', id);
        } catch (e) {
            console.log(e);
        }
    },

    async getBySignalR({commit}, id) {
        var data = null;
        try {
            var params = "?requestId=" + id
            data = await api.Get("RequestService/Request/RequestById" + params);
            commit('loadById', data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //отметить прочтение
    async markReadRequest({commit}, id) {
        try {
            var getparams = '?requestId=' + id;
            await api.Post("RequestService/Request/Read" + getparams, null);
            commit('markRead', id);
        } catch (e) {
            console.log(e);
        }
    },

    //отправить в архив
    async archive({commit}, requestId){
        try{
            let params=`?requestId=${requestId}`
            await api.Post("RequestService/Request/Archive"+params);
            commit("archiveRequest", requestId);
        }catch (e) {
            console.log(e);
            throw new Error(e);
        }
    }
}
